import { render, staticRenderFns } from "./testContent.vue?vue&type=template&id=4fbb1933&scoped=true&"
import script from "./testContent.vue?vue&type=script&lang=js&"
export * from "./testContent.vue?vue&type=script&lang=js&"
import style0 from "./testContent.vue?vue&type=style&index=0&id=4fbb1933&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbb1933",
  null
  
)

export default component.exports